import Vue from 'vue'
import ImageKit from 'imagekitio-vue'

export const ImageKitURLEndpoint = process.env.VUE_APP_IMAGEKIT_ENDPOINT

Vue.use(ImageKit, {
  urlEndpoint: ImageKitURLEndpoint
})
